import {
    useCallback,
    useMemo,
} from 'react'

import AttachmentContainer from './AttachmentContainer'

type Props = {
    name?: string,
    title?: string,
    value?: {
        id: number
    }[],
    onChange: (...args: any) => void,
    className?: string,
    disabled?: boolean,
    required?: boolean,
    upload?: boolean,
    multiple?: boolean
    acceptType?: string,
}

const defaultProps: Partial<Props> = {
    title: 'Attachments',
    name: 'attachments',
    value: [],
    className: '',
    disabled: false,
    required: false,
    upload: undefined,
    multiple: true,
    acceptType: undefined,
}

const AttachmentsObjectSelector = ({
    title,
    name,
    onChange,
    value,
    className,
    disabled,
    required,
    upload,
    multiple,
    acceptType,
}: Props) => {
    const localOnChange = useCallback((newValue) => {
        const tNewValue = newValue ? newValue.map((id) => {
            return {
                id,
            }
        }) : []

        onChange(tNewValue)
    }, [onChange])

    const localValue = useMemo(() => {
        const coverterValue = value?.map(({
            id,
        }) => {
            return id
        })

        return coverterValue
    }, [value])

    return (
        <AttachmentContainer
            onChange={localOnChange}
            value={localValue}
            className={className}
            title={title}
            disabled={disabled}
            required={required}
            name={name}
            upload={upload}
            multiple={multiple}
            acceptType={acceptType}
        />
    )
}

AttachmentsObjectSelector.defaultProps = defaultProps

const Component = {
    AttachmentsObjectSelector,
}

export type AttachmentsObjectSelectorConfig = {
    componentName: keyof typeof Component,
    upload?: boolean,
    multiple?: boolean,
    acceptType?: string,
}

export default AttachmentsObjectSelector
